import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<void, 'articleCard'>({
  name: 'BlogCuratedArticleList',
  uniqId: 'iX6Wy2',
})(({ brandColors, spacing, breakpoints, typography }, _params, classes) => ({
  wrapper: {
    width: '100%',
  },

  listHeading: {
    paddingBottom: spacing(0),
    borderBottom: `${typography.pxToRem(4)} solid ${brandColors.chargeBlue}`,

    [breakpoints.up('md')]: {
      paddingBottom: spacing(1),
    },
  },

  articleCard: {
    padding: `${spacing(0)} 0`,
    display: 'flex',
    flexDirection: 'column',
    gap: typography.pxToRem(4),

    [breakpoints.up('sm')]: {
      padding: `${spacing(1)} 0`,
      gap: typography.pxToRem(-1),
    },

    [breakpoints.up('md')]: {
      padding: `${spacing(2)} 0`,
    },

    [`& + .${classes.articleCard}`]: {
      borderTop: '1px solid black',
    },
  },

  articleHeading: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',

    '& > a': {
      textDecoration: 'inherit',
    },

    '&:hover': {
      textDecoration: 'underline',
    },
  },

  details: {
    color: brandColors.tintsNeutral20,
  },
}));

export default useStyles;
